// === CREATIVE APPS & WEBSITES DATABASE === //
// Easy-to-edit app collection for your child's website

// Default apps (used if nothing in localStorage)
const DEFAULT_APPS = [
    {
        id: 1,
        name: "Creatoria Play Quest",
        description: "A fun puzzle build and play app! Solve puzzles and create amazing things! 🧩✨",
        url: "https://creatoria-play-quest.lovable.app/",
        image: "", // Add screenshot URL here or leave empty to use icon placeholder
        icon: "🧩",
        category: "games",
        featured: true,
        dateCreated: "2024-12-01",
        tags: ["puzzle", "games", "creative", "play"],
        openInNewTab: true
    }
];

// Load apps from localStorage or use defaults
function loadAppsFromStorage() {
    try {
        const stored = localStorage.getItem('kidsCreativeApps');
        if (stored) {
            return JSON.parse(stored);
        }
    } catch (e) {
        console.error('Error loading apps from storage:', e);
    }
    return DEFAULT_APPS;
}

// Save apps to localStorage
function saveAppsToStorage(apps) {
    try {
        localStorage.setItem('kidsCreativeApps', JSON.stringify(apps));
        return true;
    } catch (e) {
        console.error('Error saving apps to storage:', e);
        return false;
    }
}

// Get current apps database
function getAppsDatabase() {
    return loadAppsFromStorage();
}

// Update apps database
function updateAppsDatabase(apps) {
    saveAppsToStorage(apps);
    // Update global variable
    if (typeof window !== 'undefined') {
        window.APPS_DATABASE = apps;
    }
}

// Initialize APPS_DATABASE
let APPS_DATABASE = loadAppsFromStorage();

// === HELPER FUNCTIONS === //

// Get all apps
function getAllApps() {
    return APPS_DATABASE.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
}

// Get apps by category
function getAppsByCategory(category) {
    if (category === 'all') return getAllApps();
    return APPS_DATABASE.filter(app => app.category === category);
}

// Get featured apps
function getFeaturedApps() {
    return APPS_DATABASE.filter(app => app.featured);
}

// Search apps by tag
function searchAppsByTag(tag) {
    return APPS_DATABASE.filter(app => 
        app.tags.some(t => t.toLowerCase().includes(tag.toLowerCase()))
    );
}

// Export for use in other files
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        APPS_DATABASE,
        getAllApps,
        getAppsByCategory,
        getFeaturedApps,
        searchAppsByTag
    };
}

// Make available globally in browser
if (typeof window !== 'undefined') {
    window.APPS_DATABASE = APPS_DATABASE;
    window.getAllApps = getAllApps;
    window.getAppsByCategory = getAppsByCategory;
    window.getFeaturedApps = getFeaturedApps;
    window.searchAppsByTag = searchAppsByTag;
    window.getAppsDatabase = getAppsDatabase;
    window.updateAppsDatabase = updateAppsDatabase;
    window.saveAppsToStorage = saveAppsToStorage;
    window.loadAppsFromStorage = loadAppsFromStorage;
}

